import React from 'react';

interface TagProps {
  children: React.ReactNode;
}

export const Tag = ({ children }: TagProps) => {
  return <span className="tw-rounded-md tw-bg-black/5 tw-py-4 tw-px-8 tw-text-12">{children}</span>;
};
